import Model from '@/models/Model'

export default {
    mixins: [
        Model
    ],

    data() {
        return {
            table: 'addresses',
            name: 'address',
            class: 'Modules\\Address\\Entities\\Address'
        }
    }
}